import {Action} from '../../../../../common/types/common';
import {BiometricsDTO} from '../../../common/types/epics';

export const GOT_BIOMETRICS_DATA_STEP_STATE_ACTION: Action = {
    name: 'GOT_BIOMETRICS_DATA_STEP_STATE_ACTION',
    action: (biometrics: BiometricsDTO) => ({
        biometrics,
        type: GOT_BIOMETRICS_DATA_STEP_STATE_ACTION.name
    })
};

export const BIOMETRICS_RESET_ACTION: Action = {
    name: 'BIOMETRICS_RESET_ACTION',
    action: () => ({
        type: BIOMETRICS_RESET_ACTION.name
    })
};

export const BIOMETRICS_RESETED_ACTION: Action = {
    name: 'BIOMETRICS_RESETED_ACTION',
    action: () => ({
        type: BIOMETRICS_RESETED_ACTION.name
    })
};

export const BIOMETRICS_DEACTIVATE_FINGERPRINTS_CAPTURE_ACTION: Action = {
    name: 'BIOMETRICS_DEACTIVATE_FINGERPRINTS_CAPTURE_ACTION',
    action: () => ({
        type: BIOMETRICS_DEACTIVATE_FINGERPRINTS_CAPTURE_ACTION.name
    })
};